module.exports = __webpack_public_path__ + "img/sidenav-item-new-order.b6c261c6.svg";